module.exports = __webpack_public_path__ + "img/div26.310271dd.png";